import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {
  constructor(private router: Router, private userSvc: UserService) {

  }

  canActivate() {
    if (this.userSvc.isLoggedIn()) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }


}

